import { render, staticRenderFns } from "./AdminCategory.vue?vue&type=template&id=810c0acc&scoped=true"
import script from "./AdminCategory.vue?vue&type=script&lang=js"
export * from "./AdminCategory.vue?vue&type=script&lang=js"
import style0 from "./AdminCategory.vue?vue&type=style&index=0&id=810c0acc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810c0acc",
  null
  
)

export default component.exports